export default __webpack_public_path__ + "static/media/expired.80a0e16d.png";